export default __webpack_public_path__ + "static/media/500.f3b51151.woff";